module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/youtube-03993749f203d0464766cd23c8e150c1.svg&quot;;"